import {
  centerOfMass,
  booleanPointInPolygon,
  pointOnFeature
} from '@turf/turf';
import { featureCollection } from '@turf/helpers';
import { datadogLogs } from '@datadog/browser-logs';

// One label anchor point per field, guaranteed to sit INSIDE the shape:
// centerOfMass when it lands inside, pointOnFeature otherwise (a plain
// centroid falls outside concave L/U-shaped fields). v2-map scoped.
const getFieldLabelPoints = (features: any[]) => {
  const points: any[] = [];
  features.forEach((f: any) => {
    try {
      const center = centerOfMass(f);
      const anchor = booleanPointInPolygon(center, f)
        ? center
        : pointOnFeature(f);
      // Attach properties explicitly — turf's properties argument differs
      // between v5 and v6 and nests them, breaking Mapbox's ['get', 'name'].
      points.push({ ...anchor, properties: { ...f.properties } });
    } catch (error) {
      // Degenerate geometry: skip the label rather than emit a NaN point.
      datadogLogs.logger.error(
        'Skipping map label for field with invalid geometry',
        { fieldId: f?.properties?.id, error }
      );
    }
  });
  return featureCollection(points);
};

export default getFieldLabelPoints;
